export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8317.12e55615.jpg";